import React, { useEffect, useState } from "react";
import { Button, Row, Col, Card, Table, NavLink } from "react-bootstrap";
import { LAYOUT } from "constants.js";
import CsLineIcons from "cs-line-icons/CsLineIcons";
import Clamp from "components/clamp";
import _ from "lodash";
import PropTypes from "prop-types";

import Academics from "./academics";
import Certifications from "./certifications";
import Trainings from "./trainings";
import Projects from "./projects";
import Workex from "./workex";

const Overview = ({ user, tabHandler, ...props }) => {
  const { academicRecord, studentProfile, academicBatch, certification, training, project, workex: exp } = user;

  const std10 = _.find(academicRecord || [], { gradlevelId: "std10" });
  const std12 = _.find(academicRecord || [], { gradlevelId: "std12" });
  const dip = _.find(academicRecord || [], { gradlevelId: "dip" });
  const ug = _.find(academicRecord || [], function (item) {
    return item.gradlevelId === "ug";
  });
  
  //const enrollemntBatch = studentProfile.enrollmentBatchId;

  return (
    <div>
      <Row className="row-cols-1 row-cols-md-2 row-cols-xxl-2 g-2">
        <Col className="col-md-12 col-xxl-7">
          <Card border="white" className="mb-2">
            <Card.Body>
              <div className="ms-0 mt-0 mb-3 ucase-small-heading text-primary">INTERNSHIPS & WORK-EXPERIENCE</div>
              {(exp && !_.isEmpty(exp))? exp.map((item, index) => <Workex index={index} key={item.id} user={user} workex={item} tabHandler={tabHandler} />) : <div class="text-muted">No workex or internships added.</div>}
            </Card.Body>
          </Card>
          <Card border="white" className="mb-2">
            <Card.Body>
              <div className="ms-0 mt-0 mb-3 ucase-small-heading text-primary">PROJECT SUMMARY</div>
              {(project && !_.isEmpty(project))? project.map((item, index) => <Projects index={index} key={item.id} user={user} project={item} tabHandler={tabHandler} />) : <div class="text-muted">No projects added.</div> }
            </Card.Body>
          </Card>
          <Card border="white" className="mb-2">
            <Card.Body className="d-flex flex-column justify-content-start">
              <div className="ms-0 mt-0 mb-3 ucase-small-heading text-primary">ACADEMIC SUMMARY</div>
              {(ug && !_.isEmpty(ug)) || (std10 && !_.isEmpty(std10)) || (std12 && !_.isEmpty(std12)) || (dip && !_.isEmpty(dip)) ? <Academics user={user} tabHandler={tabHandler} /> : <div class="text-muted">No academic records added.</div>}
            </Card.Body>
          </Card>
        </Col>
        <Col className="col-12 col-lg-12 col-xl-12 col-xxl-5">
          <Card border="white" className="mb-3">
            <Card.Body>
              <div className="ms-0 mt-0 mb-3 ucase-small-heading text-primary">CERTIFICATIONS</div>
              {certification && !_.isEmpty(certification) ? certification.map((item, index) => <Certifications index={index} key={item.id} user={user} certification={item} tabHandler={tabHandler} />) : <div class="text-muted">No certifications added.</div>}
              <div className="ms-0 mt-4 mb-3 ucase-small-heading text-primary">TRAININGS</div>
              {training && !_.isEmpty(training) ? training.map((item, index) => <Trainings index={index} key={item.id} user={user} training={item} tabHandler={tabHandler} />) : <div class="text-muted">No trainings added.</div>}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/*
      <Row className="g-0">
        <Col className="mb-2">
          <Card className="h-100">
            <Card.Body className="d-flex flex-column justify-content-start">
              <h2 className="ms-1 mt-0 mb-4 text-small text-muted mb-2"><i className={`bi-book me-3`} style={{ 'fontSize': '1.2rem',position:'relative',top:'3px'}} />ACADEMIC SUMMARY</h2>
              { btech && !_.isEmpty(btech) && 
              <Row className="g-0">
                <Col xs="auto" className="sw-7 d-flex flex-column justify-content-center align-items-center position-relative me-3">
                  <div className="w-100 d-flex" />
                  <div className="bg-foreground sw-7 sh-7 rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center mt-0">
                    <div className="bg-gradient-light sw-5 sh-5 rounded-xl">
                      <div className="text-white d-flex justify-content-center align-items-center h-100 text-small text-center lh-1">
                      <div>{btech.qualifyingYear}</div>
                      </div>
                    </div>
                  </div>
                  <div className="w-100 d-flex h-100 justify-content-center position-relative">
                    <div className="line-w-1 bg-separator h-100 position-absolute" />
                  </div>
                </Col>
                <Col className="mb-4">
                  <div className="d-flex flex-column justify-content-start mt-2">
                    <h5 className="text-primary">{academicBatch[enrollemntBatch].course.name} ({academicBatch[enrollemntBatch].branch.name})</h5>
                    <div className="text-alternate">Batch : {academicBatch[enrollemntBatch].fromYear} - {academicBatch[enrollemntBatch].toYear}{(btech.qualifyingMarks && btech.qualifyingMarks!=="")?` | Marks Obtained : ${btech.qualifyingMarks}%`:""}</div>
                    <div className="text-muted mt-1">{academicBatch[enrollemntBatch].institute.name}, {academicBatch[enrollemntBatch].institute.city}</div>
                    <div className="text-muted mt-1">Affiliated to: {academicBatch[enrollemntBatch].university.name}</div>
                  </div>
                </Col>
              </Row>
              }
              { std12 && !_.isEmpty(std12) && 
              <Row className="g-0">
                <Col xs="auto" className="sw-7 d-flex flex-column justify-content-center align-items-center position-relative me-3">
                  <div className="w-100 d-flex" />
                  <div className="bg-foreground sw-7 sh-7 rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center mt-0">
                    <div className="bg-gradient-light sw-5 sh-5 rounded-xl">
                      <div className="text-white d-flex justify-content-center align-items-center h-100 text-small text-center lh-1">
                      <div>{std12.qualifyingYear}</div>
                      </div>
                    </div>
                  </div>
                  <div className="w-100 d-flex h-100 justify-content-center position-relative">
                    <div className="line-w-1 bg-separator h-100 position-absolute" />
                  </div>
                </Col>
                <Col className="mb-4">
                  <div className="d-flex flex-column justify-content-start mt-3">
                    <h5 className="text-primary">12<sup>th</sup><span className="text-separator ps-1 pe-1">|</span>{std12.qualifyingInstitution.replace("|", ", ")}</h5>
                    <div className="text-alternate">Year of Graduation : {std12.qualifyingYear} | Marks Obtained : {std12.qualifyingMarks}% </div>
                    <div className="text-muted mt-1">Affiliated to: {(std12.affiliatingInstitution && std12.affiliatingInstitution!=="")?std12.affiliatingInstitution:"--"}</div>
                  </div>
                </Col>
              </Row>
              }
              { std10 && !_.isEmpty(std10) && 
              <Row className="g-0">
                <Col xs="auto" className="sw-7 d-flex flex-column justify-content-center align-items-center position-relative me-3">
                  <div className="w-100 d-flex" />
                  <div className="bg-foreground sw-7 sh-7 rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center">
                    <div className="bg-gradient-light sw-5 sh-5 rounded-xl">
                      <div className="text-white d-flex justify-content-center align-items-center h-100 text-small text-center lh-1">
                        <div>{std10.qualifyingYear}</div>
                      </div>
                    </div>
                  </div>
                  <div className="w-100 d-flex h-100" />
                </Col>
                <Col className="mb-4">
                  <div className="d-flex flex-column justify-content-start mt-3">
                    <h5 className="text-primary">10<sup>th</sup><span className="text-separator ps-1 pe-1">|</span>{std10.qualifyingInstitution.replace("|", ", ")}</h5>
                    <div className="text-alternate">Year of Graduation : {std10.qualifyingYear} | Marks Obtained : {std10.qualifyingMarks}% </div>
                    <div className="text-muted mt-1">Affiliated to: {(std10.affiliatingInstitution && std10.affiliatingInstitution!=="")?std10.affiliatingInstitution:"--"}</div>
                  </div>
                </Col>
              </Row>
              }
            </Card.Body>
          </Card>
        </Col>
      </Row>
      */}
    </div>
  );
};

export default Overview;
